module.exports = __webpack_public_path__ + "img/team-dark-04.b2e9dc2c.jpg";